export default __webpack_public_path__ + "static/media/fabric1.a7393ccb.png";